/**
 * assets/hero-slideshow.js
 * Controller for sections/hero-slideshow.liquid
 */
(function () {
  'use strict';

  function initHeroSlideshow(root) {
    if (!root || root.dataset.hsInitialized === 'true') return;
    root.dataset.hsInitialized = 'true';

    var autoplayEnabled = root.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    var transparentDesktop = root.dataset.transparentDesktop === 'true';
    var transparentMobile = root.dataset.transparentMobile === 'true';

    /* Fallback section IDs to re-render after ajax add-to-cart.
       Overridden by data-cart-sections="id-one,id-two" on the root element. */
    var cartSectionIds = (root.dataset.cartSections || 'cart-drawer,cart-icon-bubble')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);

    var desktopSlides = Array.prototype.slice.call(root.querySelectorAll('[data-desktop-slide]'));
    var desktopTabs = Array.prototype.slice.call(root.querySelectorAll('[data-desktop-tab]'));
    var mobileTrack = root.querySelector('[data-mobile-track]');
    var mobileSlides = Array.prototype.slice.call(root.querySelectorAll('[data-mobile-slide]'));
    var mobileDots = Array.prototype.slice.call(root.querySelectorAll('[data-mobile-dot]'));
    var toast = root.querySelector('[data-cart-toast]');

    var total = Math.max(desktopSlides.length, mobileSlides.length, 1);
    var current = 0;
    var timer = null;

    /* ---------------- desktop ---------------- */
    function setDesktopSlide(index) {
      desktopSlides.forEach(function (el) {
        el.classList.toggle('is-active', parseInt(el.dataset.slideIndex, 10) === index);
      });
      desktopTabs.forEach(function (el) {
        var active = parseInt(el.dataset.slideIndex, 10) === index;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    desktopTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        goTo(parseInt(tab.dataset.slideIndex, 10), true);
      });
    });

    /* ---------------- mobile ---------------- */
    function setMobileSlide(index, smooth) {
      if (!mobileTrack || !mobileSlides[index]) return;
      var slideWidth = mobileTrack.clientWidth;
      mobileTrack.scrollTo({ left: slideWidth * index, behavior: smooth === false ? 'auto' : 'smooth' });
      mobileSlides.forEach(function (slide) {
        slide.classList.toggle('is-active', parseInt(slide.dataset.slideIndex, 10) === index);
      });
      mobileDots.forEach(function (dot) {
        dot.classList.toggle('is-active', parseInt(dot.dataset.slideIndex, 10) === index);
      });
    }

    mobileDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.slideIndex, 10), true);
      });
    });

    if (mobileTrack) {
      var scrollTimeout;
      mobileTrack.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          var index = Math.round(mobileTrack.scrollLeft / mobileTrack.clientWidth);
          current = index;
          mobileSlides.forEach(function (slide) {
            slide.classList.toggle('is-active', parseInt(slide.dataset.slideIndex, 10) === index);
          });
          mobileDots.forEach(function (dot) {
            dot.classList.toggle('is-active', parseInt(dot.dataset.slideIndex, 10) === index);
          });
          setDesktopSlide(index);
        }, 120);
      }, { passive: true });

      ['touchstart', 'pointerdown'].forEach(function (evt) {
        mobileTrack.addEventListener(evt, stopAutoplay, { passive: true });
      });
      ['touchend', 'pointerup'].forEach(function (evt) {
        mobileTrack.addEventListener(evt, restartAutoplay, { passive: true });
      });
    }

    /* ---------------- shared nav ---------------- */
    function goTo(index, userInitiated) {
      current = ((index % total) + total) % total;
      setDesktopSlide(current);
      setMobileSlide(current, true);
      if (userInitiated) restartAutoplay();
    }
    function next() { goTo(current + 1, false); }

    function startAutoplay() {
      if (!autoplayEnabled || total < 2) return;
      stopAutoplay();
      timer = setInterval(next, autoplaySpeed);
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function restartAutoplay() {
      if (!autoplayEnabled) return;
      stopAutoplay();
      startAutoplay();
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
    setDesktopSlide(0);
    setMobileSlide(0, false);

    /* ---------------- transparent header ---------------- */
    function applyTransparentHeader() {
      var mobileNow = window.matchMedia('(max-width: 749px)').matches;
      var shouldBeTransparent = mobileNow ? transparentMobile : transparentDesktop;
      document.documentElement.classList.toggle('hs-transparent-header-desktop', shouldBeTransparent);
    }
    applyTransparentHeader();
    window.addEventListener('resize', applyTransparentHeader);

    function onScroll() {
      document.documentElement.classList.toggle('hs-header-scrolled', window.scrollY > 40);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    /* ---------------- add to cart ---------------- */
    var cartButtons = Array.prototype.slice.call(root.querySelectorAll('[data-add-to-cart]'));
    cartButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        addToCart(btn);
      });
    });

    function addToCart(btn) {
      if (btn.disabled || btn.classList.contains('is-loading')) return;

      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.classList.add('is-loading');

      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

      // Capture live node references BEFORE the request goes out — this is
      // what lets us swap the exact right DOM later without guessing IDs.
      var targets = computeSectionTargets();

      var body = {
        id: variantId,
        quantity: 1,
        sections: Object.keys(targets),
        sections_url: window.location.pathname
      };

      fetch(rootPath + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          btn.classList.remove('is-loading');

          if (data && data.status) {
            showToast(data.description || 'That item is unavailable right now.');
            return;
          }

          btn.classList.add('is-added');
          showToast('Added to cart');

          // 1. Swap in fresh server-rendered HTML for the drawer + cart icon
          //    using the exact nodes captured above, so quantities/line
          //    items are correct without a reload.
          renderCartSections(data.sections, targets);

          // 2. Belt-and-suspenders: update any generic cart-count bubble
          //    that might live outside the swapped sections.
          fetch(rootPath + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (res) { return res.json(); })
            .then(updateGenericCartCount)
            .catch(function () {});

          // 3. Let any other listeners (upsells, analytics, etc.) know.
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data, bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data, bubbles: true }));

          // 4. Open the drawer immediately, re-querying it fresh since
          //    renderCartSections() may have just replaced its node.
          openCartDrawer(data);

          setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          showToast("Couldn't add to cart, please try again.");
        });
    }

    /* Update any generic cart-count element regardless of which section
       it belongs to (covers themes where the bubble isn't inside the
       drawer or cart-icon section that got swapped). */
    function updateGenericCartCount(cart) {
      if (!cart || typeof cart.item_count === 'undefined') return;
      var countEls = document.querySelectorAll(
        '[data-cart-count], .cart-count-bubble, [data-cart-item-count], .cart-count'
      );
      countEls.forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.remove('hidden');
        el.hidden = cart.item_count === 0;
      });
    }

    function showToast(message) {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      clearTimeout(toast._hideTimeout);
      toast._hideTimeout = setTimeout(function () {
        toast.classList.remove('is-visible');
      }, 2200);
    }

    /* Walk up from a live element to its enclosing Shopify section wrapper
       (id="shopify-section-{id}") and register that wrapper — along with
       the section id cart/add.js needs — in the targets map. Falls back to
       the element itself if it has its own id and no wrapper is found. */
    function registerSectionTarget(targets, el) {
      if (!el) return;

      var wrapper = el.closest('[id^="shopify-section-"]');
      if (wrapper) {
        var id = wrapper.id.replace('shopify-section-', '');
        if (!targets[id]) targets[id] = wrapper;
        return;
      }

      if (el.id && !targets[el.id]) {
        targets[el.id] = el;
      }
    }

    /* Build a map of { sectionId: liveDomNode } for everything that needs
       to be re-rendered after add-to-cart: the cart drawer, whatever
       control opens it, and any explicitly configured fallback ids. This
       captures real node references up front, so replacement later never
       depends on guessing ID naming conventions. */
    function computeSectionTargets() {
      var targets = {};

      registerSectionTarget(targets, getCartDrawer());
      registerSectionTarget(targets, getCartDrawerTrigger());

      cartSectionIds.forEach(function (id) {
        if (targets[id]) return;
        var el = document.getElementById('shopify-section-' + id) || document.getElementById(id);
        if (el) targets[id] = el;
      });

      return targets;
    }

    /* Replace each captured live node with the freshly rendered markup
       returned by cart/add.js's `sections` param, so the drawer/cart icon
       reflect the new line item instantly, with no page reload. */
    function renderCartSections(sections, targets) {
      if (!sections || !targets) return;

      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        var targetNode = targets[id];
        if (!html || !targetNode) return;

        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var replacement = targetNode.id
          ? parsed.getElementById(targetNode.id)
          : null;

        if (!replacement) {
          replacement = parsed.body.firstElementChild;
        }

        if (replacement) {
          targetNode.replaceWith(replacement);
        }
      });
    }

    function getCartDrawer() {
      return document.querySelector(
        'cart-drawer, cart-drawer-component, #cart-drawer, #CartDrawer, .cart-drawer, [data-cart-drawer]'
      );
    }

    function getCartDrawerTrigger() {
      return document.querySelector(
        '[data-cart-drawer-trigger], [aria-controls="CartDrawer"], [aria-controls="cart-drawer"], cart-drawer-opener button, a[href="/cart"], a[href$="/cart"]'
      );
    }

    function openCartDrawer(data) {
      // Re-query: renderCartSections() may have replaced the drawer node,
      // so any earlier reference to it is stale/detached.
      var drawer = getCartDrawer();

      if (drawer) {
        if (typeof drawer.renderContents === 'function' && data && data.sections) {
          try { drawer.renderContents(data); } catch (err) { /* ignore */ }
        }
        if (typeof drawer.open === 'function') {
          drawer.open();
          return;
        }
        if (typeof drawer.show === 'function') {
          drawer.show();
          return;
        }
        if (typeof drawer.showDrawer === 'function') {
          drawer.showDrawer();
          return;
        }

        // Attribute / class based open, covers most custom-element drawers.
        drawer.setAttribute('open', '');
        drawer.removeAttribute('hidden');
        drawer.setAttribute('aria-hidden', 'false');
        drawer.classList.add('active', 'is-active', 'is-open', 'animate');
        document.documentElement.classList.add('overflow-hidden');
        document.body.classList.add('overflow-hidden');
      }

      // Guaranteed fallback: click whatever control already opens the
      // drawer correctly elsewhere on the site (the header cart icon).
      var trigger = getCartDrawerTrigger();
      if (trigger && typeof trigger.click === 'function') {
        trigger.click();
      }
    }

    /* ---------------- theme editor support ---------------- */
    document.addEventListener('shopify:block:select', function (evt) {
      var block = evt.target.closest('[data-desktop-slide], [data-mobile-slide]');
      if (!block || !root.contains(block)) return;
      stopAutoplay();
      goTo(parseInt(block.dataset.slideIndex, 10), false);
    });
    document.addEventListener('shopify:block:deselect', function () {
      restartAutoplay();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-hero-slideshow]').forEach(initHeroSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var el = evt.target.querySelector('[data-hero-slideshow]');
    if (el) initHeroSlideshow(el);
  });
})();